// import { Plus, X } from "lucide-react";
// import { Spinner } from "reactstrap";
// import FormField from "../ui/FormField";
// import { Button } from "../Button";
// import { useEffect, useState } from "react";
// import accountApi from "../../api/accountApi";
// import usersApi from "../../api/usersApi";
// import { useSelector } from "react-redux";
// import WorkflowUploadManager from "../Upload/WorkflowUploadManager";
// import WorkflowDocumentsViewer from "../Upload/WorkflowDocumentsViewer";
// import { useNavigate } from "react-router-dom";

// const AddWorkflowAll = ({
//   workflowId,
//   setShowCreateTask,
//   formData,
//   setFormData,
//   handleSubmit,
//   isLoader,
//   clients,
//   workflowTemplates,
//   accountId,
//   type,
//   errors,
// }) => {
//   const [users, setUsers] = useState([]);
//   const [accounts, setAccounts] = useState([]);
//   const [showUpload, setShowUpload] = useState(false);
//   const navigate = useNavigate();
//   const token = useSelector((state) => state.auth.access_token);
//   const handleFieldChange = (name) => (val) =>
//     setFormData((prev) => ({ ...prev, [name]: val }));

// const [refreshKey, setRefreshKey] = useState(0);

// const handleUploadSuccess = () => {
//   setShowUpload(false);
//   setRefreshKey((prev) => prev + 1); 
// };

//   useEffect(() => {
//     accountApi.getAllAccounts(token, 0, 10).then((res) => {
//       const accList = res?.data?.content || [];
//       setAccounts(accList);
//     });

//     usersApi.getAllUsers(token).then((res) => {
//       setUsers(res?.data || []);
//     });
//   }, [token]);

//   const clearFormData = () => {
//     const today = new Date();
//     const tomorrow = new Date();
//     tomorrow.setDate(today.getDate() + 1);
//     setFormData({
//       name: "",
//       description: "",
//       status: "TODO",
//       category: "",
//       template: "",
//       account: { id: accountId },
//       startDate: today.toISOString().split("T")[0],
//       dueDate: tomorrow.toISOString().split("T")[0],
//     });
//   };

//   return (
//     <div
//       onClick={(e) => e.stopPropagation()}
//       className="bg-white rounded-lg shadow-xl  w-full p-3  overflow-y-auto"
//     >
//       <div className="flex flex-row items-center justify-between">
//         <h1 className="text-2xl font-semibold text-gray-800">
//           {workflowId ? "Edit Workflows" : "Create Workflows"}
//         </h1>
//         {/* <button
//           onClick={() => {
//             setShowCreateTask(workflowId ? null : false);
//             clearFormData();
//           }}
//           aria-label="Close"
//           type="button"
//           className="p-1 rounded-md bg-red-50 hover:bg-red-100 text-red-600 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-gray-400"
//         >
//           <X size={20} />
//         </button> */}
//       </div>

//       <div>
//         <div className="grid md:grid-cols-3 sm:grid-cols-2 gap-2">
//           <div className="md:col-span-3">
//             <FormField
//               label="Workflow Name"
//               type="string"
//               required
//               maxLength={100}
//               value={formData?.name}
//               onChange={handleFieldChange("name")}
//               placeholder="e.g., Monthly GST Compliance"
//               error={errors?.name}
//             />
//           </div>
//           {workflowId ? (
//             <FormField
//               label="Status"
//               type="dropdown"
//               required
//               value={formData?.status}
//               onChange={handleFieldChange("status")}
//               options={["TODO", "IN_PROGRESS", "COMPLETED"]}
//               error={errors?.status}
//             />
//           ) : (
//             <></>
//           )}
//           {type === "client" ? (
//             <></>
//           ) : (
//             <>
//               <FormField
//                 label="Client"
//                 type="dropdown"
//                 required
//                 value={formData?.account || ""}
//                 onChange={handleFieldChange("account")}
//                 options={clients?.map((u) => ({
//                   label: u.accountName || u.name ||u.accountOwner,
//                   value: String(u.id),
//                 }))}
//                 error={errors?.account}
//               />
//             </>
//           )}
//           <FormField
//             label="Assigned To"
//             type="dropdown"
//             required
//             value={formData?.assignedTo}
//             onChange={handleFieldChange("assignedTo")}
//             options={users.map((u) => ({
//               label: u.fullName,
//               value: u.id,
//             }))}
//             error={errors?.assignedTo}
//           />
//           <FormField
//             label="Category"
//             type="dropdown"
//             required
//             value={formData?.category}
//             error={errors?.category}
//             onChange={handleFieldChange("category")}
//             options={[
//               "USER_DEFINED_TEMPLATE",
//               "GST_COMPLIANCE",
//               "TDS_MANAGEMENT",
//               "AUDIT_AND_ASSURANCE",
//               "CLIENT_ONBOARDING",
//             ]}
//           />

//           <FormField
//             label="Template"
//             type="dropdown"
//             required
//             value={formData?.template}
//             error={errors?.template}
//             onChange={handleFieldChange("template")}
//             options={workflowTemplates?.map((a) => ({
//               label: a.name,
//               value: a.name,
//             }))}
//           />

//           <FormField
//             label="Start Date"
//             type="date"
//             required
//             error={errors?.startDate}
//             min={new Date().toISOString().split("T")[0]}
//             value={formData?.startDate}
//             onChange={handleFieldChange("startDate")}
//           />

//           <FormField
//             label="Due Date"
//             type="date"
//             required
//             error={errors?.dueDate}
//             min={formData?.startDate}
//             value={formData?.dueDate}
//             onChange={handleFieldChange("dueDate")}
//           />
//         </div>

//         <div className="mt-1">
//           <FormField
//             label="Description"
//             type="description"
//             error={errors?.description}
//             rows="2"
//             required
//             value={formData?.description}
//             onChange={handleFieldChange("description")}
//           />
//         </div>
//       </div>
//         {/* {workflowId && (
//                 <div className="mt-2">

// <button
//     onClick={() => setShowUpload(true)}
//     className="bg-primary text-white px-3 py-2 rounded-lg flex items-center gap-2"
//   >
//     <Plus size={16} />
//     Upload Document
//   </button>
//   </div>

//         )}
  
// <div className="py-2">
//       <WorkflowDocumentsViewer
//   workflowId={workflowId}
//   refreshKey={refreshKey}
// />
// </div> */}
//       <div className="flex flex-row items-center justify-end gap-2">
//         <button
//           type="button"
//           onClick={() => {
//             // setShowCreateTask(workflowId ? null : false);
//             navigate(-1)
//             // clearFormData?.();
//           }}
//           className="bg-red-50 py-2 px-4 border border-red-300 rounded-md text-sm font-medium text-red-700 hover:bg-red-100"
//         >
//           Cancel
//         </button>
//         {isLoader ? (
//           <Button label={<Spinner size={"sm"} />} />
//         ) : (
//           <Button
//             label={`${workflowId ? "Update" : "Save"}`}
//             onClick={handleSubmit}
//           />
//         )}
//       </div>

//       <WorkflowUploadManager
//   workflowId={workflowId}
//   isOpen={showUpload}
//   onClose={() => setShowUpload(false)}
//   onUploadSuccess={handleUploadSuccess}
// />
//     </div>
//   );
// };

// export default AddWorkflowAll;


import { Plus } from "lucide-react";
import { Spinner } from "reactstrap";
import FormField from "../ui/FormField";
import { Button } from "../Button";
import { useEffect, useState } from "react";
import accountApi from "../../api/accountApi";
import usersApi from "../../api/usersApi";
import workflowApi from "../../api/workflowApi";
import { useSelector } from "react-redux";
import WorkflowUploadManager from "../Upload/WorkflowUploadManager";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";

const AddWorkflowAll = ({ clients, workflowTemplates, type, errors }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const token = useSelector((state) => state.auth.access_token);

  const workflow = location.state?.workflow;
  const isEdit = Boolean(workflow);

  const [users, setUsers] = useState([]);
  const [showUpload, setShowUpload] = useState(false);
  const [isLoader, setIsLoader] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    description: "",
    status: "TODO",
    category: "",
    template: "",
    account: "",
    assignedTo: "",
    startDate: "",
    dueDate: "",
  });

  const handleFieldChange = (name) => (val) =>
    setFormData((prev) => ({ ...prev, [name]: val }));

  /* Load users */
  useEffect(() => {
    usersApi.getAllUsers(token).then((res) => setUsers(res?.data || []));
  }, [token]);

  /* Prefill on edit */
  useEffect(() => {
    if (isEdit) {
      setFormData({
        name: workflow.name || "",
        description: workflow.description || "",
        status: workflow.status || "TODO",
        category: workflow.category || "",
        template: workflow.template || "",
        account: workflow.accountId || "",
        assignedTo: workflow.assignedToId || "",
        startDate: workflow.startDate || "",
        dueDate: workflow.dueDate || "",
      });
    }
  }, [isEdit]);

  /* Submit */
  const handleSubmit = async () => {
    try {
      setIsLoader(true);

      if (isEdit) {
        await workflowApi.updateWorkflow(workflow.id, formData, token);
        toast.success("Workflow updated successfully");
      } else {
        await workflowApi.createWorkflow(formData, token);
        toast.success("Workflow created successfully");
      }

      navigate(-1);
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong");
    } finally {
      setIsLoader(false);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-xl w-full h-[90vh] p-3 overflow-y-auto">
      <h1 className="text-2xl font-semibold text-gray-800 mb-2">
        {isEdit ? "Edit Workflow" : "Create Workflow"}
      </h1>

      <div className="grid md:grid-cols-3 sm:grid-cols-2 gap-2">
        <div className="md:col-span-3">
          <FormField
            label="Workflow Name"
            required
            value={formData.name}
            onChange={handleFieldChange("name")}
            error={errors?.name}
          />
        </div>

        {isEdit && (
          <FormField
            label="Status"
            type="dropdown"
            value={formData.status}
            onChange={handleFieldChange("status")}
            options={["TODO", "IN_PROGRESS", "COMPLETED"]}
          />
        )}

        {type !== "client" && (
          <FormField
            label="Client"
            type="dropdown"
            required
            value={formData.account}
            onChange={handleFieldChange("account")}
            options={clients?.map((u) => ({
              label: u.accountName || u.name,
              value: String(u.id),
            }))}
          />
        )}

        <FormField
          label="Assigned To"
          type="dropdown"
          required
          value={formData.assignedTo}
          onChange={handleFieldChange("assignedTo")}
          options={users.map((u) => ({
            label: u.fullName,
            value: u.id,
          }))}
        />

        <FormField
          label="Category"
          type="dropdown"
          required
          value={formData.category}
          onChange={handleFieldChange("category")}
          options={[
            "USER_DEFINED_TEMPLATE",
            "GST_COMPLIANCE",
            "TDS_MANAGEMENT",
            "AUDIT_AND_ASSURANCE",
            "CLIENT_ONBOARDING",
          ]}
        />

        <FormField
          label="Template"
          type="dropdown"
          required
          value={formData.template}
          onChange={handleFieldChange("template")}
          options={workflowTemplates?.map((a) => ({
            label: a.name,
            value: a.name,
          }))}
        />

        <FormField
          label="Start Date"
          type="date"
          required
          value={formData.startDate}
          onChange={handleFieldChange("startDate")}
        />

        <FormField
          label="Due Date"
          type="date"
          required
          value={formData.dueDate}
          onChange={handleFieldChange("dueDate")}
        />
      </div>

      <div className="mt-2">
        <FormField
          label="Description"
          type="description"
          rows="2"
          required
          value={formData.description}
          onChange={handleFieldChange("description")}
        />
      </div>

      <div className="flex justify-end gap-2 mt-3">
        <button
          onClick={() => navigate(-1)}
          className="bg-red-50 py-2 px-4 border border-red-300 rounded-md text-sm text-red-700"
        >
          Cancel
        </button>

        {isLoader ? (
          <Button label={<Spinner size="sm" />} />
        ) : (
          <Button label={isEdit ? "Update" : "Save"} onClick={handleSubmit} />
        )}
      </div>

      <WorkflowUploadManager
        workflowId={workflow?.id}
        isOpen={showUpload}
        onClose={() => setShowUpload(false)}
      />
    </div>
  );
};

export default AddWorkflowAll;
